import type { FC, ReactNode } from 'react'

import { Layout } from '@/components/generals/layout'
import { Seo } from '@/components/generals/seo'
import { LegalPage } from '@/components/legal/legal-page'
import { termsOfService } from '@/constants/legal'

const Terms: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo title={termsOfService.title} description={termsOfService.description} />
            <LegalPage document={termsOfService} />
        </Layout>
    )
}

export default Terms
